import { _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import './core-utils.js';
import { createParser } from './parser.js';

const compose = (...parsers) => {
  let config = {};
  parsers.forEach(parser => {
    if (!parser || !parser.config) {
      return;
    }
    config = _objectSpread2(_objectSpread2({}, config), parser.config);
  });
  return createParser(config);
};

export { compose };
